import { createAPI } from '../../composable/useAPI';


export const useSessionAPI = () => {

  const api = createAPI();

  const request = {

    get: async () => {
      try {
        const response = await api.get('/api/v2/session');
        return response.data.data;
      } catch (error) {
        console.error('GET request failed:', error);
        throw error;
      }
    },
  };

  return {
    ...request
  }
}